
import React from 'react';
import { Button } from '@/components/ui/button';
import { Assessment } from '@/types/assessment';
import { FileCheck, Save, Loader2 } from 'lucide-react';

interface SaveActionsProps {
  assessment?: Assessment | null;
  loading: boolean;
  hasUnsavedChanges?: boolean;
  onSave: () => void;
  onPublish?: () => void;
  showPublish?: boolean;
}

export function SaveActions({ 
  assessment, 
  loading, 
  hasUnsavedChanges = false,
  onSave, 
  onPublish,
  showPublish = true
}: SaveActionsProps) {
  return (
    <div className="flex items-center gap-3">
      {hasUnsavedChanges && (
        <div className="flex items-center gap-2 px-3 py-1.5 bg-accent/40 border border-border rounded-md">
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
          <span className="text-sm font-medium text-foreground">Unsaved changes</span>
        </div>
      )}

      <div className="flex gap-2">
        <Button
          type="button"
          onClick={onSave}
          disabled={loading}
          variant={hasUnsavedChanges ? "default" : "outline"}
          size="sm"
          className={hasUnsavedChanges ? "ring-2 ring-ring ring-offset-2 ring-offset-background" : ""}
        >
          {loading ? (
            <Loader2 className="h-4 w-4 mr-2 animate-spin" />
          ) : (
            <Save className="h-4 w-4 mr-2" />
          )}
          {assessment?.status === 'published' ? 'Update' : 'Save Draft'}
        </Button>

        {showPublish && assessment?.status === 'draft' && onPublish && (
          <Button type="button" onClick={onPublish} disabled={loading} variant="secondary" size="sm">
            <FileCheck className="h-4 w-4 mr-2" />
            Publish
          </Button>
        )}
      </div>
    </div>
  );
}
